import React, { Component } from "react";

// MetisMenu
import MetisMenu from "metismenujs";

//i18n
import { withTranslation } from "react-i18next";

import { connect } from "react-redux";
import {
  changeLayout,
  changeLayoutWidth,
  changeSidebarTheme,
  changeSidebarType,
  changePreloader,
} from "../../store/actions";
import withRouter from "../Common/withRouter";
import SidebarMenu from "./SidebarMenu";

class SidebarContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pathName: this.props.router.location.pathname,
    };
  }

  componentDidMount() {
    this.initMenu();
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      if (this.props.type !== prevProps.type) {
        this.initMenu();
      }
    }
    if (
      this.props.router.location.pathname !== prevProps.router.location.pathname
    ) {
      this.setState({ pathName: this.props.router.location.pathname }, () => {
        this.activateMenu();
      });
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }

  initMenu() {
    new MetisMenu("#side-menu");
    this.activateMenu();
  }

  activateMenu() {
    const { pathName } = this.state;

    var ul = document.getElementById("side-menu");
    if (!ul) return;
    var items = ul.getElementsByTagName("a");

    // Remove all active/mm-active/mm-show classes first
    for (var i = 0; i < items.length; ++i) {
      items[i].classList.remove("active");
      items[i].classList.remove("mm-active");
    }
    var allLi = ul.getElementsByTagName("li");
    for (var k = 0; k < allLi.length; ++k) {
      allLi[k].classList.remove("mm-active");
    }
    var allUl = ul.getElementsByTagName("ul");
    for (var m = 0; m < allUl.length; ++m) {
      allUl[m].classList.remove("mm-show");
    }

    // Find and activate the matching item
    var matchingMenuItem = null;
    for (var j = 0; j < items.length; ++j) {
      if (pathName === items[j].pathname) {
        matchingMenuItem = items[j];
        break;
      }
    }
    if (matchingMenuItem) {
      this.activateParentDropdown(matchingMenuItem);
    }
  }

  activateParentDropdown = (item) => {
    item.classList.add("active");
    const parent = item.parentElement;

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show");

        const parent3 = parent2.parentElement;

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement;
          if (parent4) {
            parent4.classList.add("mm-active");
          }
        }
      }
      return false;
    }
    return false;
  };

  render() {
    return (
      <React.Fragment>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{this.props.t("Menu")}</li>
            <SidebarMenu />
          </ul>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  return { ...state.Layout };
};

export default withRouter(
  connect(mapStatetoProps, {
    changeLayout,
    changeSidebarTheme,
    changeSidebarType,
    changeLayoutWidth,
    changePreloader,
  })(withTranslation()(SidebarContent)),
);
